module.exports = __webpack_public_path__ + "img/8f3719e.jpg";